import { useEffect, useState } from "react";
import SearchComponent from "./SearchComponent";
import TableElements from "./TableElements";
import ListElementsMobile from "./ListElementsMobile";
import Pagination from "../../Helper/Pagination";
import { deleteIgo, deleteIgoTheme, fetchIgo, getIgoThemePages } from "../../HTTP/countries";


export const IgoThemesAdmin = () => {
    const localUser = JSON.parse(localStorage.getItem("user"))
    if (!localUser.super_admin && localUser.admin_access !== 5) {
        window.location.href = '/'
    }
    const url = new URL(window.location.href)
    if (url.searchParams.get('page') === null) {
        url.searchParams.set('page', 1);
        window.history.pushState({}, '', url);
    }
    const [searchDone, setSearchDone] = useState(false);
    const [launchSearch, setLaunchSearch] = useState(false);
    const [igo, setIgo] = useState({});
    const [searchTerm, setSearchTerm] = useState(url.searchParams.get('query') === null ? '' : url.searchParams.get('query'));
    const [currentPage, setCurrentPage] = useState(parseInt(url.searchParams.get('page')));
    const [igoPerPage] = useState(10);
    const [nbIgo, setNbIgo] = useState(0);

    useEffect(() => {
        setSearchDone(false)
        
        const getIgo = async () => {
            try {
                const res = await getIgoThemePages((currentPage - 1) * igoPerPage, currentPage * igoPerPage, searchTerm)
                setIgo(res.data || [])
                setNbIgo(res.count)
                setSearchDone(true)  // Déplacé ici pour s'assurer que les données sont chargées
                setLaunchSearch(false)
            } catch (error) {
                console.error("Erreur lors du chargement des CSE:", error)
                setSearchDone(true)  // Important de définir searchDone même en cas d'erreur
                setLaunchSearch(false)
            }
        }
        getIgo()
    }, [currentPage, launchSearch, igoPerPage])

    const paginate = (pageNumber) => {
        url.searchParams.set('page', pageNumber);
        window.history.pushState({}, '', url);
        setCurrentPage(pageNumber)
    }

    const handleQuery = (e) => {
        e.preventDefault();
        url.searchParams.set('page', 1);
        url.searchParams.set('query', searchTerm);
        setCurrentPage(1)
        window.history.pushState({}, '', url);
        setLaunchSearch(true)
    }

    const handleAddThemeIgo = () => {
        window.location.href = '/admin/igo-theme/add'
    }

    const handleEditThemeIgo = (id) => {
        window.location.href = '/admin/igo-theme/edit/' + id
    }

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure to delete this IGO theme?")) {
            const res = await deleteIgoTheme(id)
            if (res) {
                alert("IGO theme deleted successfully")
                setLaunchSearch(true)
                window.location.reload()
            } else {
                alert("Error deleting IGO theme")
            }
        }
    }

    return (
        <div className="flex flex-row mt-8">
            <div className="flex-grow px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col sm:flex-row items-center justify-normal sm:justify-between mb-6 mt-8 xl:mt-0">
                    <h1 className="text-2xl font-bold text-center flex-grow mt-2">
                        Modération des Forums Globaux
                    </h1>
                </div>
                    <SearchComponent
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    handleQuery={handleQuery}
                    otherButton={{title:'Ajouter', handle:handleAddThemeIgo}}
                />
                {igo && igo.length > 0 ? (
                    <>
                <div className='hidden xl:block'>
                    <TableElements 
                        columns={[
                        {props:'name',display:"Nom complet"},
                        {props:'',display:"Actions"}
                        ]}
                        data={igo}
                        buttons={[{display:'Éditer',action:handleEditThemeIgo, color:'blue', props:'id'}, 
                        {display:'Supprimer',action:handleDelete, color:'red', props:'id'}]}
                    />
                </div>
                <div className="xl:hidden w-full px-4 space-y-4">
                    <ListElementsMobile 
                        columns={[{props:'name',display:"Nom complet"},
                            {props:'',display:"Actions"}
                        ]}
                        data={igo}
                        buttons={[{display:'Éditer',action:handleEditThemeIgo, color:'blue', props:'id'}, 
                        {display:'Supprimer',action:handleDelete, color:'red', props:'id'}]}
                        little={true}
                    />
                </div>
                {searchDone && <Pagination
                    itemsPerPage={igoPerPage}
                    totalItems={nbIgo}
                    paginate={paginate}
                    currentPage={currentPage}
                />}</>
                    ) : searchDone ? (
                    <p>Aucune donnée disponible</p>
                    ) : (
                    <p>Chargement en cours...</p>
                )}
                    
            </div>
        </div>
    )
}
